import { Dispatch, SetStateAction } from 'react';

import { IServerOrder } from '@rbi-ctg/menu';
import { OutcomeResult } from 'hooks/use-paycomet-paypal-popup/types';
import { IPaymentMethod, PaymentType } from 'state/payment/types';

export interface ICollapsible {
  collapsed?: boolean;
}

export interface IHasBorder {
  hasBorder?: boolean;
}

export interface IPaymentMethodProps {
  checkoutPaymentMethodNeedRevault?: boolean;
  enableDirectPay?: boolean;
  hasBorder?: boolean;
  handleSelect: (fdAccountId?: string) => void;
  isAddCardOpen?: boolean;
  isAddGiftCardMethodSelected?: boolean;
  methods: IPaymentMethod[];
  openAddCardOnClick: Dispatch<SetStateAction<boolean>>;
  selectedMethodId: string;
  setIsAddGiftCardMethodSelected?: Dispatch<SetStateAction<boolean>>;
  isPaycometPaypalMethodSelected?: boolean;
  isAdyenIdealMethodSelected?: boolean;
  setIsAdyenIdealMethodSelected?: Dispatch<SetStateAction<boolean>>;
  setIsPaycometSodexoMethodSelected?: Dispatch<SetStateAction<string>>;
  isPaycometSodexoMethodSelected?: string;
  setIsPaycometChequeGourmetMethodSelected?: Dispatch<SetStateAction<string>>;
  isPaycometChequeGourmetMethodSelected?: string;
  showCollapsibleMenu?: boolean;
  openPaycometPaypalOnClick?: Dispatch<SetStateAction<boolean>>;
  onResult?: (outcome: OutcomeResult) => void;
  serverOrder?: IServerOrder | null;
}

export interface IOptionTiles {
  isCashCheckoutDisabled: boolean;
  selectPaymentMethod: (v: PaymentType) => void;
}

export type PaymentMethodCategories = {
  selectedMethod: IPaymentMethod | undefined;
  unSelectedMethods: IPaymentMethod[];
  prepaidPaymentMethod: IPaymentMethod | undefined;
};

export enum CurrentSelectedMethodType {
  ADD_NEW_PAYMENT_METHOD = 'addNewPaymentMethod',
  ADD_NEW_GIFT_CARD = 'addNewGiftCard',
  ADD_NEW_CARD = 'addNewCard',
  SELECTED_PAYMENT_METHOD_OPTION = 'selectedPaymentMethodOption',
  ADD_NEW_PAYMENT_PAYPAL = 'addNewPaymentPaypal',
  PAY_VIA_IDEAL = 'payViaIdeal',
  ADD_NEW_PAYMENT_SODEXO = 'addNewPaymentSodexo',
  ADD_NEW_PAYMENT_CHEQUE_GOURMET = 'addNewPaymentChequeGourmet',
}
